import IconsExperiment from './IconsExperiment';
import loadable from '@loadable/component';

const VehicleIconV3 = loadable(() => import('./VehicleIconV3'));

const VehicleIconExperiment = (props) => {
  return <IconsExperiment iconV3={<VehicleIconV3 {...props} />} />;
};

VehicleIconExperiment.displayName = 'VehicleIconExperiment';

export default VehicleIconExperiment;
